import {UpdateUserAddressCommand} from '@domain/model/Account/UserAddress/UpdateUserAddressCommand';

type UserAddressRepository = {
  setUserAddress(userAddress: UpdateUserAddressCommand): Promise<Record<string, boolean> | null>;
};

const SetUserAddress =
  (userAddressRepository: UserAddressRepository) =>
  (userAddress: UpdateUserAddressCommand): Promise<Record<string, boolean> | null> => {
    const {userId, name, surname, address, postalCode, cityName, phoneNumber} = userAddress || {};
    if (!userId || !name || !surname || !address || !postalCode || !cityName || !phoneNumber) {
      return Promise.resolve(null);
    }

    return userAddressRepository.setUserAddress(userAddress);
  };

export {SetUserAddress};
